import { Component, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";
import { environment } from "../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";
import { GridComponent } from "../grid/grid.component";
import * as config from "../../../assets/grid_config.json";
import { Router } from "@angular/router";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  providers: [GridComponent],
})
export class HomeComponent implements OnInit {
  gridConfig: any = (config as any).default;
  isLoding = true;
  appConstant: any;
  category = true;
  data: any;
  homeData: any;
  apiParam = { type: "", slug: "", limit: 20, offset: 0, feature: false, banner: true };
  subcategory = [];
  investiLanguage: any;
  loadMore = false;
  initStatus: boolean;
  viewMore = false;
  show = true;
  content = [
    this.gridConfig.grid_content.interviewsTitle,
    "recommendedData",
    this.gridConfig.grid_content.trendingContentsTitle,
    this.gridConfig.grid_content.partnerContent,
  ];
  featuredData: any = [];
  shimmer = {
    bannerStatus: true,
    categoryStatus: true,
  };
  watchingData: boolean;
  recommended: boolean;
  type: any
  constructor(
    public service: BaseService,
    public translate: TranslateService,
    private titleService: Title,
    public gridComponent: GridComponent,
    private router: Router,

  ) { }

  ngOnInit(): void {
    this.type = 'home';
    window.scrollTo(0, 0);
    if (localStorage.getItem(environment.localStorageLangKey)) {
      this.investiLanguage = JSON.parse(
        localStorage.getItem(environment.localStorageLangKey)
      );
      this.translate.use(this.investiLanguage);
    }

    this.translate.onLangChange.subscribe((e: any) => {
      this.titleService.setTitle(e.translations.PAGE_TITLE);
    });
    this.initStatus = true;
    this.getData("");
    if (localStorage.getItem(environment.localStorageKey)) {
      this.recommended = true;
      this.watchingData = true;
      this.service.listStatus = true;
    }
    this.appConstant = environment;
  }

  watching: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ['<i class="mdi mdi-arrow-left"></i>', '<i class="mdi mdi-arrow-right"></i>'],
    responsive: {
      0: {
        items: 3.5,
      },
      380: {
        items: 3.5,
      },
      450: {
        items: 4.5,
      },
      650: {
        items: 4.5,
      },
      991: {
        items: 7,
      },
      1366: {
        items: 7,
      },
      1840: {
        items: 8,
      },
    },
    nav: true,
  };

  playOff() {
    this.service.playerReady = false;
  }

  getData(from) {
    const localdata = JSON.parse(
      localStorage.getItem(environment.pagesLocalStorageKey)
    );
    let index = -1;
    if (localdata) {
      index = localdata
        .map((el) => {
          return el.hasOwnProperty("home");
        })
        .indexOf(true);
    }
    if (localdata && index != -1) {
      this.data = localdata[index]["home"];
      if (this.data.featured.length > 0) {
        this.featuredData = this.data;
      }
      this.homeData = localdata[index]["home"];
      this.subcategory = localdata[index]["home"].subcategory;
      this.loadMore = false;
      this.category = false;
      this.isLoding = false;
    } else {
      this.moreData(from);
    }
  }
  moreData(from) {
    if (this.initStatus) {
      let localdata = JSON.parse(
        localStorage.getItem(environment.pagesLocalStorageKey)
      );
      if (!localdata) {
        localdata = [];
      }
      const index = localdata.findIndex((values) => values["home"]);
      this.service.categoryData(this.apiParam).subscribe(
        (data: any) => {
          this.isLoding = false;
          if (this.featuredData.length === 0) {
            this.featuredData = data;
          }
          this.data = data;
          if (from === "") {
            this.subcategory = [];
          }
          if (this.data.subcategory.length > 0) {
            this.viewMore = true;
            this.category = false;
            this.loadMore = false;
            this.show = true;
            this.subcategory = this.subcategory.concat(this.data.subcategory);
            this.service.getBackgroundImage(this.subcategory[0]?.content[0]);

            if (index != -1) {
              localdata[index]["home"].subcategory = localdata[index][
                "home"
              ].subcategory.concat(this.data.subcategory);
            } else {
              localdata.push({ ["home"]: this.data });
            }
            localStorage.setItem(
              environment.pagesLocalStorageKey,
              JSON.stringify(localdata)
            );
          } else {
            this.viewMore = false;
            this.category = false;
            this.loadMore = false;
            this.show = false;
          }
        },
        (err) => {
          if (err) {
            this.loadMore = false;
            this.viewMore = false;
            this.category = false;
            this.isLoding = false;
          }
        }
      );
    }
  }
  /*
    This function is use for set background image.
   */

  onScroll() {
    const offset = this.apiParam.limit + this.apiParam.offset;
    this.loadMore = true;
    if (this.viewMore) {
      if (this.data.subcategory.length == offset && this.loadMore) {
        this.apiParam.offset = this.apiParam.limit + this.apiParam.offset;
        this.moreData("pagination");
      } else {
        this.loadMore = false;
      }
    } else {
      this.loadMore = false;
    }
  }
  viewMoreData() {
    this.loadMore = true;
    this.show = false;
    if (this.data.subcategory.length > 0 && this.loadMore) {
      this.apiParam.offset = this.apiParam.limit + this.apiParam.offset;
      this.moreData("pagination");
    }
  }
}
